<template>
  <div class="page-dialog-layer" v-if="visible">
    <div class="common_popup_header_top">
      <div class="popup_right"><el-button @click="cancel()">返回</el-button></div>
      <div class="popup_title" v-if="title">{{ title }}</div>
    </div>
    <slot name="layer-header-front"></slot>
    <slot></slot>
    
    <slot name="footer"></slot>
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false);
      this.$emit('close')
    },
  }
};
</script>
<style lang="scss" scoped>
.page-dialog-layer {
      display: block;
      position: fixed;
      top: 100px;
      left: 280px;
      right: 12px;
      bottom: 20px;
      background: #fff;
      z-index: 999;
    overflow: auto;
  .fl {
    display: inline-block;
  }
  .clear {
    clear: both;
  } /*清除浮动*/
  .layer-body-front {
    // padding: 12px 0;
  }
  .page-main-layer{
    padding: 0 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/elDialogZdy.vue